<!--
secret-text
用例：
<secret-text v-model="secret" :hide-length="5" position="right" />

-->
<template>
  <div class="secret-text-component">
    <span class="text">{{ text }}</span>
    <span class="m-l-5">
      <i v-if="isVisible" class="el-icon-view" @click="toggleVisible(false)"></i>
      <i v-else class="iconfont lc-icon-view-off" @click="toggleVisible(true)"></i>
    </span>
  </div>
</template>

<script>
const MIDDLE = 'middle'
const LEFT = 'left'
const RIGHT = 'right'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    hideLength: {
      type: Number,
      default: 0
    },
    position: {
      type: String,
      default: MIDDLE
    },
    maxLength: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      text: this.value,
      isVisible: false
    }
  },
  watch: {
    value: function(val) {
      this.text = val
      this.toggleVisible(this.isVisible)
    }
  },
  mounted() {
    this.toggleVisible(false)
  },
  methods: {
    toggleVisible(visible) {
      this.isVisible = visible
      if (visible) {
        this.text = this.value
      } else {
        this.text = this.encryptedText()
      }
    },
    encryptedText() {
      if (this.text === null) this.text = ''

      let length = this.text.length
      if (this.hideLength) {
        let secretBeginIndex = Math.floor((length - this.hideLength) / 2)
        switch (this.position) {
          case MIDDLE:
            return this.text.substring(0, secretBeginIndex) + '*'.repeat(this.hideLength) + this.text.substring(secretBeginIndex + this.hideLength)
          case LEFT:
            return this.text.slice(this.hideLength, length).padStart(length, '*')
          case RIGHT:
            return this.text.slice(0, length - this.hideLength).padEnd(length, '*')
        }
      } else {
        if (length > this.maxLength) {
          return '*'.repeat(this.maxLength)
        }
        return this.text.replace(/./g, '*')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.secret-text-component {
  display: inline-block;
  vertical-align: top;
  max-width: 700px;
  .text {
    overflow-wrap: break-word;
  }
  img {
    cursor: pointer;
    margin-left: 10px;
  }
}

i {
  font-size: 16px;
  cursor: pointer;
}
</style>
